import type { JSX } from 'react';
import { Link } from 'react-router-dom';
import { Trash2, Mail, Calendar } from 'lucide-react';
import { TableCell } from '@/components/ui/table';
import { Button } from '@/components/ui/button';

function formatDate(dateString: string): string {
  return new Date(dateString).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
}

export function CandidateInfoCell({
  id,
  name,
  email,
}: {
  id: string;
  name: string;
  email: string;
}): JSX.Element {
  return (
    <TableCell>
      <div>
        <Link to={`/candidates/${id}`} className="font-medium text-primary hover:underline">
          {name}
        </Link>
        <p className="text-sm text-muted-foreground flex items-center gap-1">
          <Mail className="h-3 w-3" />
          {email}
        </p>
      </div>
    </TableCell>
  );
}

export function NotesCell({ notes }: { notes?: string | null }): JSX.Element {
  return (
    <TableCell>
      {notes ? (
        <p className="text-sm text-muted-foreground truncate max-w-[200px]" title={notes}>
          {notes}
        </p>
      ) : (
        <span className="text-sm text-muted-foreground">-</span>
      )}
    </TableCell>
  );
}

export function AppliedCell({ appliedAt }: { appliedAt: string }): JSX.Element {
  return (
    <TableCell>
      <div className="flex items-center gap-1 text-sm text-muted-foreground">
        <Calendar className="h-3 w-3" />
        {formatDate(appliedAt)}
      </div>
    </TableCell>
  );
}

export function UnlinkCell({ onUnlink }: { onUnlink: () => void }): JSX.Element {
  return (
    <TableCell className="text-right">
      <Button variant="ghost" size="icon" onClick={onUnlink} title="Unlink candidate">
        <Trash2 className="h-4 w-4 text-destructive" />
      </Button>
    </TableCell>
  );
}
